import { Breadcrumb } from "antd";

const TrackingBreadCrumb = ({ selectedKeywords, selectedKeywordsQueue }) => {
  const commonTextStyle = { padding: "4px" }; //{ "fontSize": breadCrumbFontSize, "height": "fit-content", "width": "fit-content" };
  // const multiTextStyle = {}; //{"fontSize": breadCrumbFontSize}

  const getSelected = (kw) => {
    return selectedKeywords.find((item) => item.value === kw.value);
  };

  const getStyle = (kw) => {
    let style = {};
    if (getSelected(kw)) {
      style = {
        backgroundColor: "var(--explore-color)",
        color: "white",
        fontWeight: "bold",
      };
    } else {
      style = {};
    }

    return {
      ...commonTextStyle,
      ...style,
    };
  };

  const itemsToDisplay = selectedKeywordsQueue.map(function (line) {
    if (line.length === 1) {
      return {
        title: <span style={getStyle(line[0])}>{line[0].value}</span>,
      };
    } else if (line.length > 1) {
      const lineMenuItems = line.slice(1).map((subline, index) => {
        return {
          key: `${index}`,
          label: <span style={getStyle(subline)}>{subline.value}</span>,
        };
      });
      return {
        title: <span style={getStyle(line[0])}>{line[0].value}</span>,
        menu: {
          items: lineMenuItems,
        },
      };
    } else {
      return {
        title: <span style={commonTextStyle}></span>,
      };
    }
  });

  return (
    <Breadcrumb
      // style={{ height: breadCrumbFontSize }}
      separator={<span style={commonTextStyle}>{">"}</span>}
      items={itemsToDisplay}
    />
  );
};

export default TrackingBreadCrumb;
